import { render } from "./VMAComponent.vue?vue&type=template&id=1b0de78e&scoped=true"
import script from "./VMAComponent.vue?vue&type=script&lang=js"
export * from "./VMAComponent.vue?vue&type=script&lang=js"

import "./VMAComponent.vue?vue&type=style&index=0&id=1b0de78e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0de78e"]])

export default __exports__